module.exports = __webpack_public_path__ + "img/hainan.04831793.jpg";